export default __webpack_public_path__ + "static/media/Add.14047ef7.svg";